module.exports = __webpack_public_path__ + "static/media/BOTIM Pay.aa3024cc.svg";